module.exports = __webpack_public_path__ + "static/media/gilles-lambert-mSK5nNsAsLY-unsplash.04939fd1.jpg";